















































































































































































import { Vue, Component } from 'vue-property-decorator';
import LeftImageFeature from '@/components/public/splash/LeftImageFeature.vue';
import RightImageFeature from '@/components/public/splash/RightImageFeature.vue';
import DemoRequest from '@/components/public/DemoRequest.vue';
import AOS from 'aos';
import { Feature } from '../../common/types';

interface Quote {
  body: string;
  author: string;
}

interface PagePath {
  title: string;
  path: number;
}

enum Path {
  Brand,
  Dispensary,
  BrandPartner
}

@Component({
  components: {
    RightImageFeature,
    LeftImageFeature,
    DemoRequest,
  },
})
export default class LandingPage extends Vue {
  // Data
  overlayDialog = true;

  mainChrnclDescription =
    'This platform houses all the necessary assets, trade tools, and educational material for a brand plus much more. And the best part is, it’s fully customizable and can be modified at any time with tracking capabilities on the back end and a secure network. Chrncl is also a way to educate, train, and incentivize budtenders with little management on your end. Think of it as your own virtual Willy Wonka’s Chocolate factory.';

  pagePaths: Array<PagePath> = [
    {
      title: 'Brand',
      path: Path.Brand,
    },
    {
      title: 'Dispensary',
      path: Path.Dispensary,
    },
    {
      title: 'Brand Partner',
      path: Path.BrandPartner,
    },
  ];

  hasChosenPath = false;

  features: Array<Feature> = [
    {
      header: 'Brand Hub',
      subheader: 'Securely house all of your brand assets in one place.',
      anchor: 'brandcenter',
      body:
        'Are you getting the same email from every dispensary asking for your logos or product information? Are you spending a lot of time responding to specific asks because you’re the gatekeeper to all brand’s assets? Why not house all your art files and brand guidelines in one place where you can control access and monitor? <br /><br />The Brand Center easily and securely houses all of your brand assets in one place, where all of your marketing and trade partners can access it to get the necessary information they need.',
      image: require('@/assets/img/public/brand_center.png'),
    },
    {
      header: 'Content Hub',
      subheader:
        'Organizes content that needs to be shared with all your partners.',
      anchor: 'contenthub',
      body:
        'Creating branded content takes time, money and other resources to produce. But while you may have some epic photos, videos and graphics, are they being used to their fullest potential? When it comes content that needs to be shared with all your partners, staying organized with your latest collateral is essential. <br /><br />The Content Hub is not only a central place for storing assets, but you can track the usage, update files as desired, and create a home for all your various materials across social media platforms. Whether it’s social media product shots or an educational training video, this hub will help you and your brand partners stay organized. ',
      image: require('@/assets/img/public/content_hub.png'),
    },
    {
      header: 'Trade Tools',
      subheader: 'Helps you manage your trade marketing program.',
      anchor: 'tradetools',
      body:
        'Dispensaries are looking for support, but often each one can have a different ask. What if there was a place where everything from simple marketing collateral to large scales merchandising displays could be requested by dispensaries in a simple and orderly fashion? We know, sounds too good to be true.<br /><br />Tools of the trade are essential in moving your business forward and this platform helps you manage your trade marketing program. From the latest SKU assortment and most up to date sell sheets, to POS inventory management and the ability to request new in-store collateral, we’ve got all your trade-bases covered.  ',
      image: require('@/assets/img/public/trade_tools.png'),
    },
    {
      header: 'Budtender Hub',
      subheader: 'Built for all of the budtenders in your brand’s universe.',
      anchor: 'budtender',
      body:
        'The hardest nut to crack in the cannabis industry is budtender affinity. It’s like every budtender needs the knowledge level of a sommelier, but then needs to be able to convey those ideas to someone who normally just drinks light beer. And it doesn’t matter how you good your brand story is if these frontline warriors aren’t preaching your good word correctly!<br /><br />The Budenter Hub was built for all of the budtenders in your brand’s universe (no matter what state or store they’re in). This is where your trusted tenders get trained + certified, can participate in brand loyalty / rewards programs and get special access to merch and more.  ',
      image: require('@/assets/img/public/budtender_hub.png'),
    },
  ];

  brandFeatures: Array<Feature> = this.features;

  brandPartnerFeatures: Array<Feature> = [
    {
      header: 'Brand Hub',
      subheader:
        'Seamlessly access your clients’ brand assets all in one place. No attachments, no password protected sites, no accidental shares.',
      anchor: 'brandcenter',
      body:
        'As brand partner, your goal is to take a brand to the next level. But hunting down assets and getting access to all brand materials can often be tricky. Relatable? We feel your pain. The Brand Center is a place where influencers, agencies, and various other collaborators can easily find all the essential brand assets they need to ensure they’re up to speed with all brand messaging and really understand a brand at its core. <br /><br />As a partner, you can seamlessly access your clients’ brand assets all in one place. No attachments, no password protected sites, no accidental shares.',
      image: require('@/assets/img/public/brand_center.png'),
    },
    {
      header: 'Content Hub',
      subheader:
        'A focal point for sharing and spreading the content you create for a brand.',
      anchor: 'contenthub',
      body:
        'Why create it, if you aren’t going to share it world wide? And to think a TikTok video could go viral if it was accessible to the right people. The Content Hub is a focal point for sharing and spreading the content you create for a brand. <br /><br />You have a lot of different clients to manage, including their wide breadth of content. Imagine a place where you can get what you need, when you need it - with no additional email exchanges or approvals needed. ',
      image: require('@/assets/img/public/content_hub.png'),
    },
  ];

  dispensaryFeatures: Array<Feature> = [
    {
      header: 'Brand Hub',
      subheader:
        'A single place where you can get the brand assets you need, when you need them.',
      anchor: 'brandcenter',
      body:
        'Getting the correct, most up to date assets from all of your brands can be a huge pain and dispensaries have to keep track of a variety of brand assets for a multitude of brands. Logos change, style guides get refreshed. How do you know what to use and when?<br /> <br />The Brand Center, a single place where you can get the brand assets you need, when you need them. It’s also an easy-access portal for budtenders to grab the right asset, at the right time, with no external communication required.',
      image: require('@/assets/img/public/brand_center.png'),
    },
    {
      header: 'Content Hub',
      subheader:
        'Whether it’s product photo or promo videos for social, this hub will help you and your brand partners stay organized. ',
      anchor: 'contenthub',
      body:
        'Budtenders are the master of your universe of brands…but sometimes that means keeping track of ALL of the content that comes with those brands. The Content Hub, a single place where you can grab the content you need, for the right brand with no lengthy email chains, attachments or approvals needed. How nice is that? Whether it’s product photo or promo videos for social, this hub will help you and your brand partners stay organized. ',
      image: require('@/assets/img/public/content_hub.png'),
    },
    {
      header: 'Trade Tools',
      subheader: 'Helps you easily access the trade marketing assets you need.',
      anchor: 'tradetools',
      body:
        'Remember that time you needed a new display but getting quotes based on your needs was too time consuming? What about when you requested a demo, but never heard back from the brand? Trade marketing can be so cumbersome, BUT, we’ve put the control back at your fingertips. <br /> <br />Download the latest collateral for new SKUs, transact on the POS you want and create the dispensary you envisioned, all without leaving your computer.',
      image: require('@/assets/img/public/trade_tools.png'),
    },
    {
      header: 'Budtender Hub',
      subheader: 'Built for your budtenders across every location.',
      anchor: 'budtender',
      body:
        'Budtenders are a brand’s best friend…sometimes brands forget that, but not us! The Budtender Hub is an essential element of the chrncl platform, because we understand that budtenders are an essential part of the equation for success. This hub gives budtenders a place to train, engage with brands and their products and get rewarded for their efforts.',
      image: require('@/assets/img/public/budtender_hub.png'),
    },
  ];

  quotes: Array<Quote> = [
    {
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      author: 'John Smith',
    },
    {
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      author: 'John Smith',
    },
    {
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      author: 'John Smith',
    },
  ];

  chrnclHeader = 'chrncl is your ';

  chrnclDescription =
    'Here we are. Through years of reform, red tape and continued debates over legalization, cannabis has fully emerged in the world of commerce as a legitimate, fully funded industry that continues to expand and grow at lighting speed. But...the industry hasn’t fully grown up just yet. <br /><br />When it comes to sales and marketing, there are tools missing in cannabis that other “traditional” industries have been using for years. We see this as an opportunity to create more streamlined communication between brands, dispensaries, distributors, and partners. Afterall, communication and engagement are key, and currently there’s been no central place for this. <br /><br />That’s why we created chrncl.';

  chosenPath: number | null = null;

  screenHeight = 0;
  // Methods

  pathChosen(path) {
    this.chosenPath = path;
    this.hasChosenPath = false;
    this.overlayDialog = false;
    window.scrollTo(0, 0);
    if (path === Path.Brand) {
      this.features = this.brandFeatures;
      this.hasChosenPath = true;
      return;
    }
    if (this.chosenPath === Path.Dispensary) {
      this.features = this.dispensaryFeatures;
      this.hasChosenPath = true;
      return;
    }
    if (this.chosenPath === Path.BrandPartner) {
      this.features = this.brandPartnerFeatures;
      this.hasChosenPath = true;
    }
  }

  mounted(): void {
    AOS.init();
    this.screenHeight = window.innerHeight;
  }
}
